<template>
  <div>
    <api-header :id="id" tag="h4">{{ $t('documentation.api.server.title') }}</api-header>
    <div v-if="server && server.variables">
      <table v-if="tableData" class=".documentation min-w-full text-sm font-light">
        <thead class="border-b font-medium border-neutral-500">
          <tr>
            <th v-for="header in tableData.headers" :key="header" scope="col" class="px-6 py-4">
              {{ header }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="row in tableData.rows"
            :key="row.name"
            class="border-b border-primary-200 bg-primary-100 text-neutral-800"
          >
            <td class="px-6 py-4 font-medium">{{ row.name }}</td>
            <td class="px-6 py-4 font-medium">{{ row.description }}</td>
            <td class="px-6 py-4">{{ row.defaultValue }}</td>
            <td class="px-6 py-4">{{ row.options }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script setup lang="ts">
import { PropType, computed } from 'vue';
import { OpenAPIV3 } from 'openapi-types';
import ApiHeader from '@/components/api/content/common/ApiHeader.vue';
import parseServerUrlDataForTableView from '@/utils/docs/api/parseServerUrlData';

const props = defineProps({
  id: { type: String, required: true },
  server: { type: Object as PropType<OpenAPIV3.ServerObject>, required: true },
});

const tableData = computed(() => parseServerUrlDataForTableView(props.server));
</script>
